export default __webpack_public_path__ + "static/N0220-6cdd69c2443f5f0ede740155f68b12ec.png";